(function () {
    'use strict';

    var timer;
    var header = $(".js-nav");
    var navItems = header.find(".js-nav-item");
    var moreMenu = header.find('.js-more-menu');
    var waitTime = 100;
    var navOpen = false;

    function open(_navItem) {
        close(navItems.not(_navItem));
        _navItem.addClass("top-nav__item--open");

        if (_navItem.hasClass('top-nav__item--more')) {
            moreMenu.removeClass('more-menu--no-animate');
            header.addClass('top-nav--more-opened');
        }

        if (_navItem.hasClass("top-nav__item--current")) {
            navItems.filter(".top-nav__item--current").addClass("top-nav__item--non-hover");
        }
    }

    function close(_navItem) {
        if (navOpen) {
            _navItem.addClass("top-nav__item--no-animate");
        } else {
            _navItem.removeClass("top-nav__item--no-animate");
        }

        if (_navItem.hasClass('top-nav__item--more')) {
            header.removeClass('top-nav--more-opened');

            if (navOpen) {
                moreMenu.addClass('more-menu--no-animate');
            }
        }

        _navItem.removeClass("top-nav__item--open");
        navItems.filter(".top-nav__item--current").removeClass("top-nav__item--non-hover");
    }

    function wait(callback, _navItem) {
        clearTimeout(timer);
        timer = setTimeout(function() {
            callback(_navItem);
        }, waitTime);
    }

    navItems.on("mouseenter", function() {
        navOpen = true;
        wait(open, $(this));
    });

    header.on("mouseleave", function() {
        navOpen = false;
        wait(close, navItems);
    });

    moreMenu.hover(
        function () {
            navOpen = true;
            clearTimeout(timer);
        },
        function () {
            navOpen = false;
            wait(close, navItems);
        }
    );

    header.on('click', '.top-nav__item--more', function (e) {
        e.preventDefault();
        return false;
    });

    $('.social-list__item').socialOverlayToggle();
})();
